import type { NativeMessage } from './contracts';
import MessageHandler from './MessageHandler';

export default class IncomingMessage<Event, Payload extends Record<string, any>>
  implements NativeMessage<any, Payload>
{
  readonly event: Event;

  readonly payload: Payload;

  readonly source: string;

  private _wasHandled: boolean = false;

  constructor(
    message: NativeMessage<any, any>,
    private readonly handlers: MessageHandler<Event>[]
  ) {
    this.event = message.event;
    this.payload = message.payload;
    this.source = message.source;
  }

  get wasHandled(): boolean {
    return this._wasHandled;
  }

  handleMessage() {
    this.handlers.forEach(handler => {
      if (!handler.test(this)) return;

      handler.handle(this);
      this._wasHandled = true;
    });
  }
}
